
import { useEffect, useState } from "react";
import ProjectWidgetRow from "../../base/components/ProjectWidgetRow";
import { gui, macro } from "../../base/data/categories";
import { ProjectModel } from "../../base/models/projectModel";
import { fetchProjects } from "../../base/service/service";

export const MacrosView = () => {
  const title = "Macros & GUIs";
  const [projects, setProjects] = useState<ProjectModel[]>();

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchProjects({filterCategory: [gui,macro]});

      setProjects(data);
    };

    fetchData();
  }, []);
  return (
    <div className="inline-flex flex-col gap-5 text-justify w-full">
      <div>
        <div className="flex flex-row items-center justify-between">
          <h3 className="flex-1">{title}</h3>
          <div className="inline-flex flex-row gap-4"></div>
        </div>
        <hr className="border-t border-black" />

        <div className="my-4 inline-flex flex-col w-full">
          {projects?.map((project) => (
            <ProjectWidgetRow key={project.key} project={project} />
          ))}
        </div>
      </div>
    </div>
  );
};
